import script from "./WCCarouselModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCCarouselModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCCarouselModern.vue?vue&type=style&index=0&id=7ef4632a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef4632a"]])

export default __exports__